module.exports = __webpack_public_path__ + "static/static.event/img/logo-new.04d3d9b2.png";